import { UserPreferenceKey, type UserPreferences } from '../types';

/**
 * Normalize semantically equivalent representations so diffs only reflect true differences.
 * Example: Taxonomies 'adaptive' vs { default: true } should be treated the same.
 */
export function normalizePreferencesForDiff(
  preferences: UserPreferences
): UserPreferences {
  const cloned = JSON.parse(JSON.stringify(preferences)) as UserPreferences;

  // Only compare role and skill inside the taxonomies key; ignore any effective* fields
  const taxonomies = cloned[UserPreferenceKey.Taxonomies];
  if (taxonomies) {
    const { role, skill } = taxonomies;
    cloned[UserPreferenceKey.Taxonomies] = { role, skill };
  }

  return cloned;
}
